import { render } from "./TwitterTimeline.vue?vue&type=template&id=c9887858"
import script from "./TwitterTimeline.vue?vue&type=script&lang=js"
export * from "./TwitterTimeline.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__